module.exports = __webpack_public_path__ + "img/ablois_square.587e0c54.jpg";